__turbopack_context__.v({
  "block": "_RAh5W_block",
  "buying": "_RAh5W_buying",
  "buyingGrid": "_RAh5W_buyingGrid",
  "buyingGroup": "_RAh5W_buyingGroup",
  "buyingGroups": "_RAh5W_buyingGroups",
  "directory": "_RAh5W_directory",
  "featuredCaption": "_RAh5W_featuredCaption",
  "featuredCard": "_RAh5W_featuredCard",
  "featuredGrid": "_RAh5W_featuredGrid",
  "featuredItem": "_RAh5W_featuredItem",
  "featuredLogo": "_RAh5W_featuredLogo",
  "featuredLogoFrame": "_RAh5W_featuredLogoFrame",
  "featuredName": "_RAh5W_featuredName",
  "logoFallback": "_RAh5W_logoFallback",
  "logoImage": "_RAh5W_logoImage",
  "logoSlot": "_RAh5W_logoSlot",
  "maker": "_RAh5W_maker",
  "makerBody": "_RAh5W_makerBody",
  "makerBrands": "_RAh5W_makerBrands",
  "makerIdentity": "_RAh5W_makerIdentity",
  "makerLabel": "_RAh5W_makerLabel",
  "makerList": "_RAh5W_makerList",
  "makerLogo": "_RAh5W_makerLogo",
  "makerLogoImage": "_RAh5W_makerLogoImage",
  "makerMeta": "_RAh5W_makerMeta",
  "makerName": "_RAh5W_makerName",
  "makerPlain": "_RAh5W_makerPlain",
  "makers": "_RAh5W_makers",
  "makersNote": "_RAh5W_makersNote",
  "note": "_RAh5W_note",
});
